import { OverlayRef } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  _overlayRef: OverlayRef;
  readonly _congratsInit:Subject<boolean> = new Subject<boolean>();
  public congratsInit$:Observable<boolean> = this._congratsInit.asObservable();
  constructor() { }
  initializeCongrats(flag:boolean){
    this._congratsInit.next(flag);
  }
  attachOverlayRef(x:OverlayRef){
    this._overlayRef = x;
  }
  destroyOverlayRef(){
    if(this._overlayRef) {
      this._overlayRef.dispose(); // Completely removes overlay and event listeners
      this._overlayRef = null;
    }
  }
  

  
}
